import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
const ShellNavItemsContext = createContext([]);
export function ShellNavItemsProvider({ items, children, }) {
    return _jsx(ShellNavItemsContext.Provider, { value: items, children: children });
}
export function useShellNavItems() {
    return useContext(ShellNavItemsContext);
}
//# sourceMappingURL=shellNav.js.map